import React from 'react';
import PromoCardRow from '../promo-card-row/promo-card-row';
import PromoRow from '../../../models/promo/PromoRow';

type Promos = {
  content: PromoRow[];
};

export default function Promos({ content }: Promos) {
  return (
    <section id='homepage-promos' className='py-5'>
      <div className='container'>
        {content.map((el) => (
          <PromoCardRow id={el.id} config={el.config} key={el.id} promoApp={el.promoApp} />
        ))}
      </div>
    </section>
  );
}
